module.exports = __webpack_public_path__ + "static/media/identidad.65d110fb.svg";